
import { cn } from "@/lib/utils";
import { useSidebar } from "@/components/ui/sidebar";
import { Logo } from "@/components/ui/Logo";

export function SidebarHeader() {
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";
  
  return (
    <div className="flex items-center justify-center h-20 px-3 py-3">
      {isCollapsed ? (
        <Logo 
          size="sm"
          className="transition-all duration-300 ease-in-out"
          clickable={true}
        />
      ) : (
        <Logo 
          size="md"
          className="transition-all duration-300 ease-in-out ml-0.5" // Small left margin for visual alignment
          clickable={true}
          stacked={true} // Enable stacked layout in expanded state
        />
      )}
    </div>
  );
}
